/**
 * LOCATION: dashboard-agent/src/pages/ChatList.js
 * Agent chat list — fully mobile responsive, FA icons only
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/api';

const loadFA = () => {
  if (!document.getElementById('fa-cdn-al')) {
    const fa = document.createElement('link');
    fa.id = 'fa-cdn-al'; fa.rel = 'stylesheet';
    fa.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css';
    document.head.appendChild(fa);
  }
};

const formatTime = (ts) => {
  if (!ts) return '';
  const now  = new Date();
  const time = new Date(ts);
  const diff = Math.floor((now - time) / 1000);
  if (diff < 60)   return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400)return `${Math.floor(diff / 3600)}h ago`;
  return time.toLocaleDateString();
};

const ChatList = () => {
  const navigate  = useNavigate();
  const [chats,   setChats]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter,  setFilter]  = useState('all');
  const agent = JSON.parse(localStorage.getItem('janimony_agent') || '{}');

  useEffect(() => {
    loadFA();
    loadChats();
    const interval = setInterval(loadChats, 4000);
    return () => clearInterval(interval);
  }, []);

  const loadChats = async () => {
    try {
      const res = await API.getActiveChats(agent.businessId);
      if (res.success) setChats(res.sessions || []);
    } catch (err) { console.error('Failed to load chats:', err); }
    finally { setLoading(false); }
  };

  const handleLogout = () => {
    localStorage.removeItem('janimony_agent');
    navigate('/login');
  };

  const filtered    = chats.filter(c => filter === 'all' ? true : c.status === filter);
  const waitingCount = chats.filter(c => c.status === 'waiting').length;
  const activeCount  = chats.filter(c => c.status === 'active').length;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');
        *{box-sizing:border-box;}
        .al-page{min-height:100vh;background:#f8fafc;font-family:'DM Sans',sans-serif;}
        .al-topbar{background:#fff;padding:0 20px;height:64px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #e5e7eb;box-shadow:0 1px 4px rgba(0,0,0,0.05);position:sticky;top:0;z-index:10;}
        .al-brand{display:flex;align-items:center;gap:10px;}
        .al-brand-icon{width:36px;height:36px;border-radius:10px;background:linear-gradient(135deg,#667eea,#764ba2);display:flex;align-items:center;justify-content:center;}
        .al-brand-name{font-size:16px;font-weight:800;color:#111827;}
        .al-topbar-right{display:flex;align-items:center;gap:8px;}
        .al-agent-pill{display:flex;align-items:center;gap:7px;padding:6px 12px;background:#f3f4f6;border-radius:20px;font-size:13px;font-weight:600;color:#374151;}
        .al-refresh-btn{width:36px;height:36px;background:#f3f4f6;border:none;border-radius:9px;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#6b7280;font-size:14px;}
        .al-logout-btn{display:flex;align-items:center;gap:6px;padding:7px 14px;background:#fee2e2;color:#b91c1c;border:none;border-radius:9px;cursor:pointer;font-weight:700;font-size:13px;font-family:'DM Sans',sans-serif;}
        .al-body{padding:20px;max-width:800px;margin:0 auto;}
        .al-stats{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:20px;}
        .al-stat{background:#fff;padding:16px;border-radius:12px;text-align:center;border:1px solid #e5e7eb;box-shadow:0 1px 3px rgba(0,0,0,0.04);}
        .al-stat-val{font-size:28px;font-weight:800;color:#111827;line-height:1;}
        .al-stat-lbl{font-size:12px;color:#9ca3af;font-weight:600;margin-top:4px;}
        .al-filters{display:flex;gap:8px;margin-bottom:20px;flex-wrap:wrap;}
        .al-filter{padding:8px 16px;background:#fff;border:2px solid #e5e7eb;border-radius:8px;cursor:pointer;font-weight:600;font-size:13px;color:#374151;font-family:'DM Sans',sans-serif;transition:all 0.2s;}
        .al-filter.on{background:#667eea;color:#fff;border-color:#667eea;}
        .al-list{display:flex;flex-direction:column;gap:12px;}
        .al-card{background:#fff;padding:16px 18px;border-radius:12px;border:2px solid transparent;cursor:pointer;transition:all 0.2s;box-shadow:0 1px 3px rgba(0,0,0,0.05);}
        .al-card:hover{box-shadow:0 4px 16px rgba(0,0,0,0.1);transform:translateY(-1px);}
        .al-card.waiting{border-color:#fbbf24;background:#fffbeb;}
        .al-card-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;}
        .al-chat-id{font-size:15px;font-weight:700;color:#111827;display:flex;align-items:center;gap:8px;}
        .al-badge{padding:4px 10px;border-radius:20px;font-size:11px;font-weight:700;}
        .al-badge.waiting{background:#fef3c7;color:#92400e;}
        .al-badge.active{background:#dcfce7;color:#166534;}
        .al-preview{font-size:13px;color:#6b7280;margin:0 0 8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
        .al-card-bot{display:flex;align-items:center;gap:6px;font-size:12px;color:#9ca3af;}
        .al-loading{text-align:center;padding:60px 20px;color:#6b7280;}
        .al-empty{text-align:center;padding:60px 20px;color:#6b7280;background:#fff;border-radius:12px;border:1px solid #e5e7eb;}
        @media(max-width:500px){
          .al-stats{grid-template-columns:repeat(3,1fr);gap:8px;}
          .al-stat{padding:12px 8px;}
          .al-stat-val{font-size:22px;}
          .al-agent-pill span{display:none;}
          .al-logout-btn span{display:none;}
          .al-topbar{padding:0 14px;}
          .al-body{padding:14px;}
        }
      `}</style>

      <div className="al-page">
        {/* Top bar */}
        <div className="al-topbar">
          <div className="al-brand">
            <div className="al-brand-icon">
              <i className="fa-solid fa-headset" style={{ color: '#fff', fontSize: 16 }}></i>
            </div>
            <span className="al-brand-name">Agent Dashboard</span>
          </div>

          <div className="al-topbar-right">
            <div className="al-agent-pill">
              <i className="fa-solid fa-circle" style={{ color: '#10b981', fontSize: 8 }}></i>
              <span>{agent.name || 'Agent'}</span>
            </div>
            <button className="al-refresh-btn" onClick={loadChats} title="Refresh">
              <i className="fa-solid fa-rotate-right"></i>
            </button>
            <button className="al-logout-btn" onClick={handleLogout}>
              <i className="fa-solid fa-right-from-bracket"></i>
              <span>Logout</span>
            </button>
          </div>
        </div>

        <div className="al-body">
          {/* Stats */}
          <div className="al-stats">
            <div className="al-stat">
              <div className="al-stat-val" style={{ color: '#f59e0b' }}>{waitingCount}</div>
              <div className="al-stat-lbl">Waiting</div>
            </div>
            <div className="al-stat">
              <div className="al-stat-val" style={{ color: '#10b981' }}>{activeCount}</div>
              <div className="al-stat-lbl">Active</div>
            </div>
            <div className="al-stat">
              <div className="al-stat-val">{chats.length}</div>
              <div className="al-stat-lbl">Total</div>
            </div>
          </div>

          {/* Filters */}
          <div className="al-filters">
            {[
              { id: 'all',     label: `All (${chats.length})` },
              { id: 'waiting', label: `Waiting (${waitingCount})` },
              { id: 'active',  label: `Active (${activeCount})` },
            ].map(f => (
              <button
                key={f.id}
                className={`al-filter${filter === f.id ? ' on' : ''}`}
                onClick={() => setFilter(f.id)}
              >
                {f.label}
              </button>
            ))}
          </div>

          {/* Chat list */}
          <div className="al-list">
            {loading ? (
              <div className="al-loading">
                <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: 28, display: 'block', marginBottom: 10, color: '#667eea' }}></i>
                Loading chats...
              </div>
            ) : filtered.length === 0 ? (
              <div className="al-empty">
                <i className="fa-solid fa-comments" style={{ fontSize: 52, opacity: 0.2, display: 'block', marginBottom: 12, color: '#667eea' }}></i>
                <h3 style={{ fontSize: 18, color: '#111827', margin: '0 0 8px' }}>No chats found</h3>
                <p style={{ fontSize: 14, margin: 0 }}>Customers will appear here when they request help</p>
              </div>
            ) : filtered.map(chat => (
              <div
                key={chat.session_id}
                className={`al-card${chat.status === 'waiting' ? ' waiting' : ''}`}
                onClick={() => navigate(`/chat/${chat.session_id}`)}
              >
                <div className="al-card-top">
                  <span className="al-chat-id">
                    <i className="fa-solid fa-comment-dots" style={{ color: '#667eea', fontSize: 14 }}></i>
                    Chat #{chat.session_id.substring(0, 8)}
                  </span>
                  <span className={`al-badge ${chat.status}`}>{chat.status}</span>
                </div>
                <p className="al-preview">
                  {chat.messages?.length > 0
                    ? chat.messages[0].content.substring(0, 70) + '…'
                    : 'New conversation'}
                </p>
                <div className="al-card-bot">
                  <i className="fa-regular fa-clock" style={{ fontSize: 11 }}></i>
                  {formatTime(chat.started_at)}
                  {chat.status === 'waiting' && (
                    <span style={{ marginLeft: 'auto', fontSize: 11, color: '#f59e0b', fontWeight: 700 }}>
                      <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: 3 }}></i>
                      Needs attention
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatList;